export default __webpack_public_path__ + "static/media/5.79df3539.png";